
import { HomePageModel } from "./PageControllers/HomePageModel";

class PageController {
    
    private readonly _home: HomePageModel

    constructor(){
        this._home = new HomePageModel();
    }

    get home(){
        return this._home
    }
}

export { PageController }